// Import SCSS for sponsor rotating gallery
import '../scss/sponsor-rotating-gallery.scss';

// Sponsor Rotating Gallery - Staggered Round-Robin Flip Card Implementation
document.addEventListener('DOMContentLoaded', function() {
    const sponsorSliders = document.querySelectorAll('.trust-company-sponsor-slider');
    
    sponsorSliders.forEach(function(slider) {
        const rotationTime = parseInt(slider.dataset.rotationTime) || 4000;
        const slidesPerView = parseInt(slider.dataset.slidesPerView) || 3; // This now controls total cards, not layout
        const cardLinks = slider.querySelectorAll('.trust-company-sponsor-rotate-card-link');
        
        if (cardLinks.length === 0) return;

        // Note: Layout is now controlled by CSS responsive grid (3 desktop, 2 tablet, 1 mobile)
        // slidesPerView determines how many cards are created total, not how many per row

        // Data Manager Class - Same as before
        class DataManager {
            constructor(images) {
                this.images = images;
                this.currentImageIndex = 0;
                this.isShowingFront = true;
                
                this.frontImageIndex = 0;
                this.backImageIndex = 1 % this.images.length;
            }
            
            getCurrentImage() {
                return this.images[this.frontImageIndex];
            }
            
            getNextImage() {
                return this.images[this.backImageIndex];
            }
            
            getVisibleImageUrl() {
                const visibleIndex = this.isShowingFront ? this.frontImageIndex : this.backImageIndex;
                return this.images[visibleIndex].sponsor_url || '#';
            }
            
            rotateToNext() {
                console.log('=== ROTATION START ===');
                console.log('Before flip - currentImageIndex:', this.currentImageIndex, 'frontIndex:', this.frontImageIndex, 'backIndex:', this.backImageIndex, 'showingFront:', this.isShowingFront);
                
                // Flip to show the other side
                this.isShowingFront = !this.isShowingFront;
                
                // Get URL of image that is NOW visible
                const newVisibleUrl = this.getVisibleImageUrl();
                console.log('Now visible:', newVisibleUrl);
                
                // Move to next image in sequence
                this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
                
                // Update the hidden side to show the next image in sequence
                let imageToUpdate, updateSide;
                if (this.isShowingFront) {
                    // Now showing front, update back to next image
                    this.backImageIndex = (this.currentImageIndex + 1) % this.images.length;
                    imageToUpdate = this.images[this.backImageIndex];
                    updateSide = 'back';
                } else {
                    // Now showing back, update front to next image
                    this.frontImageIndex = (this.currentImageIndex + 1) % this.images.length;
                    imageToUpdate = this.images[this.frontImageIndex];
                    updateSide = 'front';
                }
                
                console.log('After flip - currentImageIndex:', this.currentImageIndex, 'frontIndex:', this.frontImageIndex, 'backIndex:', this.backImageIndex);
                console.log('Updating', updateSide, 'to:', imageToUpdate.image_alt);
                console.log('=== ROTATION END ===');
                
                return {
                    isShowingFront: this.isShowingFront,
                    imageToUpdate: imageToUpdate,
                    updateSide: updateSide,
                    newVisibleUrl: newVisibleUrl
                };
            }
            
            hasMultipleImages() {
                return this.images.length > 1;
            }
        }

        // Card Manager Class - Individual card control
        class CardManager {
            constructor(cardLink, cardIndex) {
                this.cardLink = cardLink;
                this.cardIndex = cardIndex;
                
                // Get images data from hidden JSON
                const imageDataScript = cardLink.querySelector('.card-images-data');
                const imagesData = JSON.parse(imageDataScript.textContent);
                
                this.dataManager = new DataManager(imagesData);
                
                // DOM elements
                this.card = cardLink.querySelector('.trust-company-sponsor-rotate-card');
                this.frontImg = cardLink.querySelector('.trust-company-sponsor-rotate-front-img');
                this.backImg = cardLink.querySelector('.trust-company-sponsor-rotate-back-img');
            }
            
            performFlip() {
                if (!this.dataManager.hasMultipleImages()) return;
                
                const rotationData = this.dataManager.rotateToNext();
                
                console.log('Card', this.cardIndex, 'flip data:', {
                    isShowingFront: rotationData.isShowingFront,
                    newVisibleUrl: rotationData.newVisibleUrl,
                    updateSide: rotationData.updateSide
                });
                
                // Perform visual flip
                this.card.classList.toggle('flipped');
                
                // Update URL immediately when flip happens
                console.log('Card', this.cardIndex, 'updating href from', this.cardLink.href, 'to', rotationData.newVisibleUrl);
                this.cardLink.href = rotationData.newVisibleUrl;
                
                // Update the hidden image after flip animation starts
                setTimeout(() => {
                    const imageData = rotationData.imageToUpdate;
                    
                    if (rotationData.updateSide === 'front') {
                        this.frontImg.src = imageData.image_url;
                        this.frontImg.alt = imageData.image_alt;
                    } else {
                        this.backImg.src = imageData.image_url;
                        this.backImg.alt = imageData.image_alt;
                    }
                }, 600); // Wait for half the flip animation (1.2s / 2)
            }
            
            addNextPreview() {
                this.card.classList.add('next-to-flip');
            }
            
            removeNextPreview() {
                this.card.classList.remove('next-to-flip');
            }
            
            destroy() {
                // this.removeNextPreview();
            }
        }

        // Staggered Round-Robin Manager
        class StaggeredRotationManager {
            constructor(cardManagers, rotationTime) {
                this.cardManagers = cardManagers;
                this.rotationTime = rotationTime;
                this.rotationQueue = [];
                this.currentInterval = null;
                this.isPaused = false;
                this.nextCardIndex = null;
                
                this.initialize();
            }
            
            initialize() {
                this.shuffleQueue();
                this.scheduleNext();
            }
            
            shuffleQueue() {
                // Create array of card indices that have multiple images
                const availableCards = this.cardManagers
                    .map((manager, index) => ({ manager, index }))
                    .filter(({manager}) => manager.dataManager.hasMultipleImages())
                    .map(({index}) => index);
                
                // Shuffle the available cards
                this.rotationQueue = [...availableCards].sort(() => Math.random() - 0.5);
                console.log('New rotation queue:', this.rotationQueue);
            }
            
            scheduleNext() {
                if (this.isPaused) return;
                
                // If queue is empty, reshuffle
                if (this.rotationQueue.length === 0) {
                    console.log('Queue empty, reshuffling...');
                    this.shuffleQueue();
                }
                
                if (this.rotationQueue.length === 0) {
                    console.log('No cards with multiple images to rotate');
                    return;
                }
                
                // Get next card to flip
                this.nextCardIndex = this.rotationQueue.shift();
                
                // Add preview animation to next card
                // if (this.nextCardIndex !== null) {
                //     this.cardManagers[this.nextCardIndex].addNextPreview();
                // }
                
                // Schedule the flip
                this.currentInterval = setTimeout(() => {
                    this.flipNext();
                }, this.rotationTime);
            }
            
            flipNext() {
                if (this.isPaused || this.nextCardIndex === null) return;
                
                const cardManager = this.cardManagers[this.nextCardIndex];
                
                // Remove preview animation
                // cardManager.removeNextPreview();
                
                // Perform flip
                cardManager.performFlip();
                
                // Clear next card
                this.nextCardIndex = null;
                
                // Schedule next flip
                this.scheduleNext();
            }
            
            pause() {
                this.isPaused = true;
                
                // Clear current timeout
                if (this.currentInterval) {
                    clearTimeout(this.currentInterval);
                    this.currentInterval = null;
                }
                
                // Remove preview animation from current next card
                // if (this.nextCardIndex !== null) {
                //     this.cardManagers[this.nextCardIndex].removeNextPreview();
                // }
                
                console.log('Staggered rotation paused');
            }
            
            resume() {
                if (!this.isPaused) return;
                
                this.isPaused = false;
                console.log('Staggered rotation resumed');
                
                // Resume scheduling
                this.scheduleNext();
            }
            
            destroy() {
                this.pause();
                this.cardManagers.forEach(manager => manager.destroy());
            }
        }

        // Create card managers
        const cardManagers = [];
        cardLinks.forEach((cardLink, index) => {
            const cardManager = new CardManager(cardLink, index);
            cardManagers.push(cardManager);
        });

        // Create staggered rotation manager
        const rotationManager = new StaggeredRotationManager(cardManagers, rotationTime);

        // Global hover control - pause ALL animations when ANY card is hovered
        function pauseAllRotations() {
            console.log('Mouse entered - pausing staggered rotations');
            slider.classList.add('paused');
            rotationManager.pause();
        }
        
        function resumeAllRotations() {
            console.log('Mouse left - resuming staggered rotations');
            slider.classList.remove('paused');
            rotationManager.resume();
        }

        // Add hover listeners to each card
        cardLinks.forEach(cardLink => {
            cardLink.addEventListener('mouseenter', pauseAllRotations);
            cardLink.addEventListener('mouseleave', resumeAllRotations);
        });
    });
});